const TaxCountry = [
  { value: 'United States', label: 'United States' },
  { value: 'UAE', label: 'UAE' },
  { value: 'Singapore', label: 'Singapore' },
  { value: 'South Africa', label: 'South Africa' },
  { value: 'Brazil', label: 'Brazil' },
];

const AnnualIncome = [
  { label: '< $20,000', value: '< $20,000' },
  { label: '$20,000 - $49,999', value: '$20,000 - $49,999' },
  { label: '$50,000 - $99,999', value: '$50,000 - $99,999' },
  { label: '$100,000 - $499,999', value: '$100,000 - $499,999' },
  { label: '$500,000 - $1,000,000', value: '$500,000 - $1,000,000' },
  { label: '>$1,000,000', value: '>$1,000,000' },
];

const EstimatedNetWorth = [
  { label: '< $25,000', value: '< $25,000' },
  { label: '$25,000 - $99,999', value: '$25,000 - $99,999' },
  { label: '$100,000 - $499,999', value: '$100,000 - $499,999' },
  { label: '$500,000 - $1,000,000', value: '$500,000 - $1,000,000' },
  { label: '>$1,000,000', value: '>$1,000,000' },
];

const Assets = [
  { label: '< $25,000', value: '< $25,000' },
  { label: '$25,000 - $99,999', value: '$25,000 - $99,999' },
  { label: '$100,000 - $499,999', value: '$100,000 - $499,999' },
  { label: '$500,000 - $1,000,000', value: '$500,000 - $1,000,000' },
  { label: '>$1,000,000', value: '>$1,000,000' },
];

const FundingSource = ['Employment Income', 'Investments', 'Inheritance', 'Business Income', 'Savings Family'];

const EmploymentStatus = ['Employed', 'Unemployed', 'Student', 'Retired'];

const AgreeOption = [
  {
    label: 'Yes',
    value: true,
  },
  {
    label: 'No',
    value: false,
  },
];

const TimeFrame = [
  {
    label: '1 Minute',
    value: '1',
  },
  {
    label: '5 Minute',
    value: '5',
  },
  {
    label: '15 Minute',
    value: '15',
  },
  {
    label: '30 Minute',
    value: '30',
  },
  {
    label: '1 Hour',
    value: '60',
  },
  {
    label: '4 Hours',
    value: '240',
  },
  {
    label: '1 Day',
    value: '1440',
  },
  {
    label: '1 week',
    value: '7200',
  },
];

const AppliedPrice = [
  {
    label: 'Close Price',
    value: '0',
  },
  {
    label: 'Open Price',
    value: '1',
  },
  {
    label: 'High Price',
    value: '2',
  },
  {
    label: 'Low Price',
    value: '3',
  },
  {
    label: 'Median Price',
    value: '4',
  },
  {
    label: 'Typical Price',
    value: '5',
  },
  {
    label: 'Weighted Price',
    value: '6',
  },
];

const MovingAverageType = [
  {
    label: 'Simple averaging',
    value: '0',
  },
  {
    label: 'Exponential averaging',
    value: '1',
  },
  {
    label: 'Smoothed averaging',
    value: '2',
  },
  {
    label: 'Linear-weighted averaging',
    value: '3',
  },
];

const SelectStyles = {
  option: (provided) => ({
    ...provided,
    color: '#101c42',
  }),
  control: (provided, state) => ({
    ...provided,
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    boxShadow: state.isFocused ? '0 0 0 0.25rem rgb(13 110 253 / 25%)' : '',
    border: 0,
    height: 40,
    borderRadius: 10,
    padding: '0 15px',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#d0dbf4',
    fontSize: 13,
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#d0dbf4',
  }),
};

const TargetAssetClass = [
  {
    label: 'Equity',
    value: 'equity',
  },
  {
    label: 'Crypto',
    value: 'crypto',
  },
  {
    label: 'Forex',
    value: 'forex',
  },
];

export {
  TaxCountry,
  AnnualIncome,
  EstimatedNetWorth,
  Assets,
  FundingSource,
  EmploymentStatus,
  AgreeOption,
  TimeFrame,
  AppliedPrice,
  MovingAverageType,
  SelectStyles,
  TargetAssetClass,
};
